import React from 'react'
import LayoutFull from '../layouts/layoutFull/LayoutFull';
import Blog from '../pagesComponents/blog/Blog';
import getPages from "../helpers/data/get/pages";
import SeoApiHandler from "../helpers/seo/SeoApiHandler";
import {
    API_ARTICLES_BLOG_LIST,
    CFG_BLOG_ARTICLES_PER_PAGE,
    generateBlogCollectionSchema
} from "../settings/content/articles";
import { JSONLD } from "../helpers/seo/seo";
import { convertEditorStateToHTML, getPlainTextFromContent } from "../components/draftEditor/export/exports";
import { NAV_BLOG } from "../settings/navigation";

export async function getStaticProps() {

    const res = await fetch(API_ARTICLES_BLOG_LIST);
    const posts = await res.json();
    let articles = posts.response.sort((a, b) => new Date(b.created) - new Date(a.created));
    articles = articles.filter(article => !!article.slug);

    const pagesCount = Math.ceil(articles.length / CFG_BLOG_ARTICLES_PER_PAGE);

    articles = articles.slice(0, CFG_BLOG_ARTICLES_PER_PAGE);

    articles = articles.map(a => ({
        ...a,
        ...{
            preview_plain: getPlainTextFromContent(a.preview),
            preview: convertEditorStateToHTML(a.preview, {}),
            content_plain: getPlainTextFromContent(a.content)
        }
    }))

    let pages = [];
    for (let i = 1; i <= pagesCount; i++) pages.push(i);

    const seo = await getPages(NAV_BLOG);

    return {
        props: {
            articles,
            page: '1',
            pages,
            seo,
            schemaData: generateBlogCollectionSchema(articles, null, seo.seo_description),
        }
    };
}

function BlogHome({articles, page, pages, seo, schemaData}) {
    return (
        <LayoutFull>
            <SeoApiHandler data={seo}/>
            <JSONLD data={schemaData} tagKey='blog-collection'/>
            <Blog articles={articles} page={page} pages={pages}/>
        </LayoutFull>
    );
}

export default BlogHome